import client from './client.js';

export const getProducts = (params) =>
  client.get('/products', { params: { limit: 200, active: true, ...params } }).then((r) => r.data);

export const searchProducts = (q) =>
  client.get('/products', { params: { search: q, limit: 50, active: true } }).then((r) => r.data.data);

export const getCategories = () =>
  client.get('/categories').then((r) => r.data.data.map((c) => c.name));
